(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohrenruhe-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-hero]').forEach((scope) => {
      const dotWrap     = scope.querySelector('[data-pdp-dots]');
      const productImg  = scope.querySelector('[data-pdp-hero-product]');
      const variantInput = scope.querySelector('[data-pdp-variant-input]');
      const priceEl     = scope.querySelector('[data-pdp-price]');
      const compareEl   = scope.querySelector('[data-pdp-compare]');
      const ctaBtn      = scope.querySelector('[data-pdp-cta]');
      const ctaLabel    = scope.querySelector('[data-pdp-cta-label]');
      const savingsEl   = scope.querySelector('[data-pdp-savings]');
      const thumbWrap   = scope.querySelector('[data-pdp-thumbs]');
      if (!dotWrap && !thumbWrap) return;

      const soldOutText = ctaLabel ? (ctaLabel.dataset.soldOut || 'Ausverkauft') : 'Ausverkauft';
      const addText     = ctaLabel ? ctaLabel.textContent.trim() : 'In den Warenkorb';

      const swapImg = (src) => {
        if (!src || !productImg) return;
        productImg.classList.add('is-swapping');
        const next = new Image();
        next.onload = () => {
          productImg.src = src;
          productImg.classList.remove('is-swapping');
        };
        next.onerror = () => productImg.classList.remove('is-swapping');
        next.src = src;
      };

      if (thumbWrap) {
        thumbWrap.addEventListener('click', (e) => {
          const t = e.target.closest('.pdp-hero__thumb');
          if (!t) return;
          thumbWrap.querySelectorAll('.pdp-hero__thumb').forEach((x) => x.classList.remove('is-active'));
          t.classList.add('is-active');
          if (t.dataset.src) swapImg(t.dataset.src);
        });
      }

      if (!dotWrap) return;

      // Coverflow peek slides — desktop gallery browser.
      // Center image tracks the selected variant (color dot). Peeks show
      // adjacent images from the product gallery (thumb strip). Clicking a
      // peek swaps that gallery image into the center and rotates.
      const peekPrev = scope.querySelector('[data-pdp-peek="prev"]');
      const peekNext = scope.querySelector('[data-pdp-peek="next"]');

      const gallerySrcs = () => {
        if (!thumbWrap) return [];
        return Array.from(thumbWrap.querySelectorAll('.pdp-hero__thumb'))
          .map((t) => t.dataset.src)
          .filter(Boolean);
      };

      // -1 means "showing the variant image"; >= 0 is an index into gallery.
      let galleryIdx = -1;

      const refreshPeeks = () => {
        if (!peekPrev || !peekNext) return;
        const srcs = gallerySrcs();
        if (srcs.length < 2) {
          peekPrev.hidden = true;
          peekNext.hidden = true;
          return;
        }
        const n = srcs.length;
        // Peek neighbours around the currently displayed slide.
        // When variant image is centered (idx=-1), peeks show the first two
        // gallery images.
        let leftSrc, rightSrc, leftIdx, rightIdx;
        if (galleryIdx === -1) {
          leftIdx = n - 1;
          rightIdx = 0;
        } else {
          leftIdx = (galleryIdx - 1 + n) % n;
          rightIdx = (galleryIdx + 1) % n;
        }
        leftSrc = srcs[leftIdx];
        rightSrc = srcs[rightIdx];
        const set = (peek, src, idx) => {
          peek.hidden = false;
          peek.dataset.galleryIdx = String(idx);
          const img = peek.querySelector('img');
          if (img && src) img.src = src;
        };
        set(peekPrev, leftSrc, leftIdx);
        set(peekNext, rightSrc, rightIdx);
      };

      refreshPeeks();

      // Warm the browser cache with every gallery image so peek clicks feel
      // instant and there's no flash between src swaps. Kept in memory to
      // prevent GC from dropping the decoded bitmaps.
      const preloaded = new Map();
      const warmGallery = () => {
        gallerySrcs().forEach((src) => {
          if (!src || preloaded.has(src)) return;
          const img = new Image();
          img.src = src;
          preloaded.set(src, img);
        });
      };
      warmGallery();

      const productTile = scope.querySelector('.pdp-hero__product-tile');
      [peekPrev, peekNext].forEach((peek) => {
        if (!peek) return;
        peek.addEventListener('click', () => {
          const idx = parseInt(peek.dataset.galleryIdx || '', 10);
          const srcs = gallerySrcs();
          if (Number.isNaN(idx) || !srcs[idx]) return;
          const newSrc = srcs[idx];

          // Preload the new center image first, then run the cross-fade
          const preload = new Image();
          preload.onload = () => {
            // Phase 1: dim + press the clicked peek, fade the center out
            peek.classList.add('is-pressed');
            if (productTile) productTile.classList.add('is-fading');

            // After the fade-out is underway, swap the center src, update
            // gallery cursor, refresh peek content (both peeks get their
            // new prev/next images), and fade everything back in.
            setTimeout(() => {
              galleryIdx = idx;
              if (productImg) productImg.src = newSrc;
              refreshPeeks();
              if (productTile) productTile.classList.remove('is-fading');
              peek.classList.remove('is-pressed');
            }, 260);
          };
          preload.onerror = () => {
            peek.classList.remove('is-pressed');
            if (productTile) productTile.classList.remove('is-fading');
          };
          preload.src = newSrc;
        });
      });

      dotWrap.addEventListener('click', (e) => {
        const dot = e.target.closest('.pdp-hero__dot');
        if (!dot) return;

        dotWrap.querySelectorAll('.pdp-hero__dot').forEach((d) => d.classList.remove('is-active'));
        dot.classList.add('is-active');

        const { src, variantId, price, comparePrice, available } = dot.dataset;

        // Image
        if (src) swapImg(src);

        // Variant input (drives the /cart/add form)
        if (variantInput && variantId && variantId !== '0') {
          variantInput.value = variantId;
        }

        // Price
        if (priceEl && price) priceEl.textContent = price;

        // Compare-at price
        if (compareEl) {
          if (comparePrice) {
            compareEl.textContent = comparePrice;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }

        // Savings pill — show parsed €-difference if we have both values
        if (savingsEl) {
          const parse = (str) => {
            if (!str) return NaN;
            const cleaned = str.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
            return parseFloat(cleaned);
          };
          const p = parse(price);
          const c = parse(comparePrice);
          if (!isNaN(p) && !isNaN(c) && c > p) {
            const diff = (c - p).toFixed(2).replace('.', ',');
            savingsEl.textContent = `Du sparst ${diff} €`;
            savingsEl.hidden = false;
          } else {
            savingsEl.textContent = '';
            savingsEl.hidden = true;
          }
        }


        // CTA available state
        if (ctaBtn) {
          const isAvailable = available === 'true';
          ctaBtn.disabled = !isAvailable;
          if (ctaLabel) ctaLabel.textContent = isAvailable ? addText : soldOutText;
        }

        // Reset gallery cursor back to variant image and refresh peeks
        galleryIdx = -1;
        refreshPeeks();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
